import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/lessons", label: "レッスン一覧" }
];

export function AdminRecurringSlotsPage() {
  return (
    <PageScaffold
      title="Admin Recurring Slots"
      description="定期枠一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに recurring slot 一覧を表示します。</p>
    </PageScaffold>
  );
}
